<app-button (clickit)="goBack()" buttonType="text" icon="chevron-left">Terug naar ETL overzicht</app-button>
@if (currentWorkflow(); as currentWorkflow) {
	<div class="header">
		<h1>{{ currentWorkflow.metadata.name }}</h1>
	</div>
	<div class="cards">
		<div class="column">
			<div class="card workflow-details">
				<h2>Details</h2>
				<div class="details-list">
					<div class="detail">
						<span>UID: </span>
						<span>{{ currentWorkflow.metadata.uid }}</span>
					</div>
					<div class="detail">
						<span>Soort: </span>
						<span>{{ soortFromName(currentWorkflow.metadata.name) }}</span>
					</div>
					<div class="detail">
						<span>Type: </span>
						<span>{{ typeFromName(currentWorkflow.metadata.name) }}</span>
					</div>
					<div class="detail">
						<span>Status: </span>
						<span> {{ currentWorkflow.status.phase }}</span>
					</div>
					<div class="detail">
						<span>Starttijd: </span>
						<span>{{ currentWorkflow.status.startedAt | date: "d-M-yyyy 'om' H:mm" }}</span>
					</div>
					@if (currentWorkflow.status.finishedAt) {
						<div class="detail">
							<span>Eindtijd: </span>
							<span>{{ currentWorkflow.status.finishedAt | date: "d-M-yyyy 'om' H:mm" }}</span>
						</div>
					}
					<div class="detail">
						<span>Gestart door: </span>
						<span>{{ workflowStarter() }}</span>
					</div>
				</div>
			</div>
			<div class="card same-parent">
				<h2>Jobs van dezelfde {{ workflowOwner() }}</h2>
				<div class="workflows">
					@for (workflow of relatedWorkflows(); track workflow.metadata.uid) {
						<div
							class="workflow"
							[class.current]="workflow.metadata.uid === currentWorkflow.metadata.uid"
							(click)="switchWorkflow(workflow)"
						>
							<span class="name" [class.active]="!workflow.status.finishedAt">{{ workflow.metadata.name }}</span>
							@if (workflow.status.startedAt) {
								<span class="time">{{ workflow.status.startedAt | date: "d-M-yyyy 'om' H:mm" }}</span>
							}
							@if (workflow.status.finishedAt) {
								<span class="time">{{ workflow.status.finishedAt | date: "d-M-yyyy 'om' H:mm" }}</span>
							}
						</div>
					}
				</div>
			</div>
		</div>
		<div class="column">
			@if (jobruns().length > 0) {
				<div class="card jobruns">
					<table>
						<thead>
							<tr>
								<th>Nummer</th>
								<th>Job</th>
								<th>Starttijd</th>
								<th>Eindtijd</th>
								<th>Pod</th>
							</tr>
						</thead>
						<tbody>
							@for (jobrun of jobruns(); track jobrun.id) {
								<tr>
									<td>
										<span>
											{{ jobrun.id }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrun.job }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrun.jobrunVa | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrun.jobrunTm | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrun.pod }}
										</span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			}
			@if (jobrunInstellingen().length > 0) {
				<div class="card instellingen">
					<table>
						<thead>
							<tr>
								@for (sortableColumn of sortableColumns; track sortableColumn) {
									<th class="sortable" (click)="sort(sortableColumn)">
										<span class="sort-header">
											{{ sortableColumn }}
											@if (sortState().column === sortableColumn) {
												<app-icon
													[name]="sortState().direction === 'asc' ? 'sorteren-oplopend' : 'sorteren-aflopend'"
													size="small"
												/>
											}
										</span>
									</th>
								}
								<th>Stap</th>
							</tr>
						</thead>
						<tbody>
							@for (jobrunInstelling of sortedJobrunInstellingen(); track jobrunInstelling.id) {
								<tr>
									<td>
										<span
											class="grafana-link"
											(click)="openGrafana(jobrunInstelling.pod, jobrunInstelling.vanaf, jobrunInstelling.totMet)"
										>
											{{ jobrunInstelling.instelling.naam }}
										</span>
									</td>
									<td>
										<div class="etl-status" [ngClass]="jobrunInstelling.instellingETLStatus.toLowerCase()">
											{{ jobrunInstelling.instellingETLStatus }}
										</div>
									</td>
									<td>
										<span>
											{{ jobrunInstelling.bulkload === 1 ? "Ja" : "Nee" }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrunInstelling.vanaf | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrunInstelling.totMet | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ doorlooptijd(jobrunInstelling.vanaf, jobrunInstelling.totMet) }}
										</span>
									</td>
									<td>
										<span [class.failed]="jobrunInstelling.stapGefaald">
											@if (jobrunInstelling.stapGefaald) {
												{{ jobrunInstelling.stapGefaald }}
											} @else if (jobrunInstelling.instellingETLStatus === InstellingETLStatus.BEZIG) {
												@let jobrunDetails = jobrunInstelling.jobrunDetails;
												@if (jobrunDetails) {
													@let currentStep = jobrunDetails.at(jobrunDetails.length - 1);
													{{ currentStep?.stap }}
													@if (currentStep?.opmerking) {
														({{ currentStep?.opmerking }})
													}
												}
											}
										</span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			} @else if (instellingOngebondenJobrunDetails().length > 0) {
				<div class="card details">
					<table>
						<thead>
							<tr>
								<th>Stap</th>
								<th>Opmerking</th>
								<th>Starttijd</th>
								<th>Eindtijd</th>
								<th>Doorlooptijd</th>
							</tr>
						</thead>
						<tbody>
							@for (jobrunDetail of instellingOngebondenJobrunDetails(); track jobrunDetail.id) {
								<tr>
									<td>
										<span
											class="grafana-link"
											(click)="openGrafana(jobrunDetail.jobrun.pod, jobrunDetail.stapVa, jobrunDetail.stapTm)"
										>
											{{ jobrunDetail.stap }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrunDetail.opmerking }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrunDetail.stapVa | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ jobrunDetail.stapTm | date: "d-M-yyyy 'om' H:mm" }}
										</span>
									</td>
									<td>
										<span>
											{{ doorlooptijd(jobrunDetail.stapVa, jobrunDetail.stapTm, jobrunDetail.jobrun.jobrunTm) }}
										</span>
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			}
		</div>
	</div>
} @else {
	<div>
		<span>Geen geldige workflow uid</span>
	</div>
}
